import React from 'react';

import Shell from './Shell';

interface Props {
  children: React.ReactNode;
}

/** Every other page: the NirmalX shell with a search bar in the header. */
const LayoutNirmalx = ({ children }: Props) => <Shell variant="page">{ children }</Shell>;

export default LayoutNirmalx;
